/**
 * Multi-select concern (product tag) links on the homepage sidebar.
 * On collection pages, Shopify facet URLs handle toggling server-side.
 */
(function () {
  const STORAGE_KEY = 'feather.sidebarConcernTags';

  /**
   * @param {string} catalogUrl
   * @param {string[]} selectedTags
   */
  function buildFilterUrl(catalogUrl, selectedTags) {
    if (!selectedTags.length) {
      return catalogUrl;
    }
    const params = selectedTags.map((tag) => `filter.p.tag=${encodeURIComponent(tag)}`);
    return `${catalogUrl}?${params.join('&')}`;
  }

  /**
   * @param {string} catalogUrl
   * @returns {string[]}
   */
  function readStoredSelection(catalogUrl) {
    try {
      const stored = sessionStorage.getItem(STORAGE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        if (Array.isArray(parsed)) {
          return parsed.filter((t) => typeof t === 'string' && t.length > 0);
        }
      }
    } catch {
      /* ignore */
    }

    try {
      const base = new URL(catalogUrl, window.location.origin);
      const current = new URL(window.location.href);
      if (current.pathname === base.pathname) {
        return current.searchParams.getAll('filter.p.tag');
      }
    } catch {
      /* ignore */
    }

    return [];
  }

  /**
   * @param {HTMLElement} root
   */
  function initRoot(root) {
    const catalogUrl = root.dataset.concernCatalog || '/collections/all';

    const storedSelection = readStoredSelection(catalogUrl);
    root.querySelectorAll('[data-concern-action="toggle"]').forEach((row) => {
      if (!(row instanceof HTMLAnchorElement)) return;
      const tag = row.dataset.concernTag;
      if (tag && storedSelection.includes(tag)) {
        row.classList.add('is-active');
        row.setAttribute('aria-current', 'true');
      }
    });

    root.addEventListener('click', (event) => {
      const row = event.target instanceof Element ? event.target.closest('[data-concern-action]') : null;
      if (!(row instanceof HTMLAnchorElement)) return;

      event.preventDefault();

      const tag = row.dataset.concernTag;
      if (!tag) return;

      let selected = readStoredSelection(catalogUrl);

      if (row.classList.contains('is-active')) {
        selected = selected.filter((t) => t !== tag);
      } else if (!selected.includes(tag)) {
        selected.push(tag);
      }

      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(selected));
      window.location.href = buildFilterUrl(catalogUrl, selected);
    });
  }

  function init() {
    document.querySelectorAll('[data-sidebar-concern-filter][data-concern-mode="index"]').forEach((root) => {
      if (root instanceof HTMLElement) {
        initRoot(root);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
